module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-content"
  }, [(_vm.$root.view == 'mobile') ? _c('div', {
    staticClass: "pp-mobile-back pp-mobile-back--light",
    on: {
      "click": function($event) {
        return _vm.$root.mobileBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-left"
  })]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pp-content__page"
  }, [_c('div', {
    staticClass: "pp-tabs"
  }, [_c('ul', {
    ref: "headers",
    staticClass: "pp-tabs__headers"
  }, [_c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse"
    }
  }, [_vm._v("\n                        Popular\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/albums"
    }
  }, [_vm._v("\n                        Albums\n                    ")])], 1), _vm._v(" "), (_vm.$root.view != 'mobile') ? _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/tracks"
    }
  }, [_vm._v("\n                        Tracks\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.view == 'mobile') ? _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/new"
    }
  }, [_vm._v("\n                        New\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/composers"
    }
  }, [_vm._v("\n                        Composers\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/ensembles"
    }
  }, [_vm._v("\n                        Ensembles\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/artists"
    }
  }, [_vm._v("\n                        Artists\n                    ")])], 1), _vm._v(" "), _c('li', {
    ref: "headerActive",
    staticClass: "pp-tabs__headers__header pp-tabs__headers__header--active"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/exclusive"
    }
  }, [_vm._v("\n                        Exclusives\n                    ")])], 1), _vm._v(" "), (_vm.$root.view == 'mobile') ? _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/tracks"
    }
  }, [_vm._v("\n                        Tracks\n                    ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pp-tabs__content"
  }, [(_vm.loading) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.albums.length > 0) ? _c('exclusive-grid', {
    attrs: {
      "reached-end": _vm.reachedEnd,
      "paginating": _vm.paginating,
      "can-paginate": true,
      "items": _vm.albums
    },
    on: {
      "paginate": _vm.loadMore
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-header pp-header--simple pp-header--image-albums pp-header--mobile-small"
  }, [_c('div', {
    staticClass: "pp-header__title"
  }, [_vm._v("\n            Pristine Streaming Exclusives\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66bb0966","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/routes/BrowseExclusives.vue
// module id = 132
// module chunks = 0 1